import React, { Fragment, Component } from 'react';
import classNames from 'classnames';
import { TweenLite } from 'gsap';
import './styles.styl';
import icons from '../../assets/comet/comet.svg';

class Carousel extends Component {
  constructor(props) {
    super(props);

    this.imgElement = null;
    this.state = {
      currentSlide: 0,
      completionTracker: {}
    };
  }

  renderSlide = (slide, index) => {
    return (
      <img
        key={index}
        src={slide.image}
        alt={slide.imageText}
        className={this.slideClassNames(index)}
        width={940}
        // height={390}
      />
    );
  };

  slideClassNames = index => {
    const { currentSlide } = this.state;
    return classNames(
      {
        'slide--visible': currentSlide === index
      },
      'slide'
    );
  };

  renderButton = back => {
    const { slides, wrap } = this.props.data;
    const { currentSlide } = this.state;
    return (
      <button
        disabled={!wrap && currentSlide === (back ? 0 : slides.length - 1)}
        className={this.controlButtonClasses(
          !wrap && currentSlide === (back ? 0 : slides.length - 1)
        )}
        onClick={() => this.moveSlide(back)}
      >
        <svg
          className="comet-icon--s controls__button__svg"
          aria-hidden="true"
          focusable="false"
        >
          <use xlinkHref={`${icons}#${back ? 'caret-left' : 'caret-right'}`} />
        </svg>
      </button>
    );
  };

  renderDots = () => {
    const { slides, dotNavigation } = this.props.data;
    let Element = dotNavigation ? 'button' : 'div';
    return slides.map((dot, i) => {
      return (
        <Element
          key={i}
          className={this.dotClassNames(i, dotNavigation)}
          onClick={dotNavigation ? () => this.dotClick(i) : undefined}
        />
      );
    });
  };

  dotClick = i => {
    const { currentSlide } = this.state;
    this.setSlideState(currentSlide, i);
  };

  dotClassNames = (index, dotNavigation) => {
    const { currentSlide, completionTracker } = this.state;
    return classNames(
      {
        'controls__dot--current': index === currentSlide,
        'controls__dot--visited': completionTracker[index],
        'controls__dot--is-button': dotNavigation === true
      },
      'controls__dot'
    );
  };

  moveSlide = back => {
    const { currentSlide } = this.state;
    const { slides, wrap } = this.props.data;

    let newSlidePosition;
    if (
      !wrap &&
      ((currentSlide === 0 && back) ||
        (currentSlide === slides.length - 1 && !back))
    ) {
      return;
    }
    if (wrap) {
      if (currentSlide === 0 && back) {
        newSlidePosition = slides.length - 1;
      } else if (currentSlide === slides.length - 1 && !back) {
        newSlidePosition = 0;
      } else {
        newSlidePosition = back ? currentSlide - 1 : currentSlide + 1;
      }
    } else {
      newSlidePosition = back ? currentSlide - 1 : currentSlide + 1;
    }
    this.setSlideState(currentSlide, newSlidePosition);
  };

  setSlideState = (currentSlide, newSlidePosition) => {
    this.animateSlides(newSlidePosition);
    this.setState({
      currentSlide: newSlidePosition,
      completionTracker: this.updateCompletionTracker(
        currentSlide,
        newSlidePosition
      )
    });
  };

  animateSlides = newSlidePosition => {
    return (this.tween = TweenLite.to('.slide', 0.75, {
      x: `${newSlidePosition * -100}%`
    }));
  };

  updateCompletionTracker = (currentSlide, newSlidePosition) => {
    const { onCompletion, data } = this.props;
    const { completionTracker } = this.state;
    let newCompletionTracker = { ...completionTracker };
    newCompletionTracker[currentSlide] = true;
    newCompletionTracker[newSlidePosition] = true;

    if (Object.keys(newCompletionTracker).length === data.slides.length) {
      onCompletion();
    }

    return newCompletionTracker;
  };

  controlButtonClasses = disabled => {
    return classNames(
      {
        'controls__button--disabled': disabled
      },
      'controls__button'
    );
  };

  render() {
    const { data } = this.props;
    const { currentSlide } = this.state;
    const { text } = data.slides[currentSlide].text;

    return (
      <Fragment>
        <div className="slide-container">
          {data.slides.map((slide, i) => {
            return this.renderSlide(slide, i);
          })}
        </div>
        <div className="controls">
          {this.renderButton(true)}
          {this.renderDots()}
          {this.renderButton()}
        </div>
        <div>
          <h2>{data.slides[currentSlide].text.title}</h2>
          {typeof text === 'string' ? (
            <p>{text}</p>
          ) : (
            <Fragment>{text}</Fragment>
          )}
        </div>
      </Fragment>
    );
  }
}

export default Carousel;



// WEBPACK FOOTER //
// ../core/src/components/Carousel/Carousel.js